import getOpeCollateralLimits from 'api/vehicles/getOpeCollateralLimits'
import useSWR from 'swr'

export const OPE_COLLATERAL_LIMITS_SWR_KEY = 'ope-collateral-limits'

const FALLBACK_MAX_ITEMS = 1

interface OpeCollateralLimits {
    maxItems: number
    isLoading: boolean
    isError: boolean
    retry: () => Promise<unknown>
}

export default function useOpeCollateralLimits(
    enabled = true,
): OpeCollateralLimits {
    const { data, error, isLoading, mutate } = useSWR(
        enabled ? OPE_COLLATERAL_LIMITS_SWR_KEY : null,
        () => getOpeCollateralLimits(),
        {
            errorRetryCount: 1,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        },
    )

    return {
        maxItems: data?.max_items ?? FALLBACK_MAX_ITEMS,
        isLoading,
        isError: enabled && !!error,
        retry: () => mutate(),
    }
}
